import React from "react";
import { useFormikContext } from "formik";
import MetadataCard from "components/MetadataCard";

/**
 * MetaKeys
 * [
  "title",
  "description",
  "name",
  "image",
  "og:image",
  "og:title",
  "og:url",
  "og:description",
  "og:type",
  "og:image:width",
  "og:image:height",
  "og:site_name",
  "twitter:site",
  "twitter:creator",
  "twitter:card",
  "twitter:title",
  "twitter:description",
  "twitter:image",
  "icon",
  "icon:sizes",
  "apple-touch-icon",
  "mask-icon",
  "mask-icon:color"
]
 */
const MetadataPreview = () => {
  const {
    values: { url, image, title, description }
  } = useFormikContext();

  return (
    <MetadataCard
      url={url}
      image={image}
      title={title}
      description={description}
    />
  );
};

export default MetadataPreview;
